
import React from 'react';
import { format } from 'date-fns';
import { Badge } from '@/components/ui/badge';
import { TableCell, TableRow } from '@/components/ui/table';
import { formatCurrency } from '@/utils/formatters';
import { Payment } from '../types';

interface PaymentRowProps {
  payment: Payment;
}

export const PaymentRow = ({ payment }: PaymentRowProps) => {
  return (
    <TableRow>
      <TableCell>{format(new Date(payment.date), 'MMM dd, yyyy')}</TableCell>
      <TableCell>
        <Badge variant={payment.type === 'salary' ? 'secondary' : 'default'}>
          {payment.type === 'salary' ? 'Salary' : 'Fee'}
        </Badge>
      </TableCell>
      <TableCell>{payment.recipient}</TableCell>
      <TableCell>
        <div>
          {payment.description}
          {payment.refundAmount && (
            <div className="text-sm text-destructive mt-1">
              Refunded: AFN {formatCurrency(payment.refundAmount)}
              {payment.refundDate && ` (${format(new Date(payment.refundDate), 'MMM dd, yyyy')})`}
            </div>
          )}
          {payment.planModifications && payment.planModifications.length > 0 && (
            <div className="text-xs text-muted-foreground mt-1">
              Modified: {format(new Date(payment.planModifications[payment.planModifications.length - 1].date), 'MMM dd, yyyy')}
            </div>
          )}
        </div>
      </TableCell>
      <TableCell>AFN {formatCurrency(payment.amount)}</TableCell>
      <TableCell>
        <Badge variant={
          payment.status === 'completed' || payment.status === 'paid' ? 'default' :
          payment.status === 'pending' ? 'destructive' : 'secondary'
        }>
          {payment.status}
        </Badge>
      </TableCell>
      <TableCell>{payment.paymentMethod || '-'}</TableCell>
      <TableCell>{payment.reference}</TableCell>
    </TableRow>
  );
};
